const { createSlice } = require('@reduxjs/toolkit');

/**
 * @type {PlayerAwardsPlayerModalState}
 */
const initialState = {
    visible: false,
    playerId: null,
    seasonPid: null,
    seasonId: null,
    player: {}
};

const playerModalSlice = createSlice({
    name: 'playerModal',
    initialState,
    reducers: {
        setPlayerModal: (state, action) => {
            Object.assign(state, action.payload);
        }
    }
});

export const playerModalReducer = playerModalSlice.reducer;

export const { setPlayerModal } = playerModalSlice.actions;
